import { Divider, Form, Input } from 'antd';
import React, { useEffect, useState } from 'react';
import { formValidatorRules } from '../../../../../common/utils';
import ModalComponent from '../../../../../components/ModalComponent';

const { Item } = Form;
const { required, whitespaceNotAllowed } = formValidatorRules;

const MaterialModal = ({
  isModalOpen,
  setIsModalOpen,
  onFinish,
  loadings,
  form,
  material,
  setMaterial,
}) => {
  const [isValidateTrigger, setIsValidateTrigger] = useState(false);

  const handleCancel = () => {
    setIsModalOpen(false);
    setMaterial();
    form?.resetFields();
  };

  useEffect(() => {
    form?.setFieldsValue({ name: material?.name });
  }, [material]);

  return (
    <>
      <ModalComponent
        open={isModalOpen}
        onCancel={handleCancel}
        onOk={form?.submit}
        title={material ? 'Edit Material' : 'Add New Material'}
        okText="Save"
        confirmLoading={loadings}
        destroyOnClose
        forceRender
      >
        <Divider />
        <Form
          form={form}
          onFinish={(values) => {
            onFinish(values);
            setIsValidateTrigger(true);
          }}
          autoComplete="off"
          layout="vertical"
          validateTrigger={isValidateTrigger ? 'onChange' : 'onSubmit'}
          onFinishFailed={() => setIsValidateTrigger(true)}
        >
          <Item
            name="name"
            label="Material Name"
            rules={[
              { ...required, message: 'Please Enter Material Name!' },
              whitespaceNotAllowed,
            ]}
          >
            <Input
              allowClear
              placeholder="Enter Material Name"
              maxLength={100}
            />
          </Item>
        </Form>
      </ModalComponent>
    </>
  );
};

export default MaterialModal;
